import type { AxiosResponse } from 'axios';

import api from '@/utils/axiosInterceptor';
import type { ApiResponse } from '@/utils/deepmerge';

import type { IItemCheckerReport } from './ItemChecker.interface';

export async function GetItemCheckerData({ days }: { days: number }) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response: AxiosResponse<ApiResponse<IItemCheckerReport[]>> =
      await api.get(`/items-card/items-main-report/${days}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
}
